module.exports = __webpack_public_path__ + "img/1587071332.2b13f3b1.jpg";